module.exports = {"id":"dp3_1l1q2","text":"Developing digital content","instructions":"Which file format is most commonly used for image content?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.1","questionType":"PickOne","random":true,"options":[{"id":"dp3_1l1q2-a1","text":"JPEG or PNG","score":1.8},{"id":"dp3_1l1q2-a2","text":"DOCX or TXT","score":0},{"id":"dp3_1l1q2-a3","text":"MP3 or WAV","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.1/l1q2.json
// module id = 1111
// module chunks = 41